/**
 * Extract user email from OIDC auth data
 * Returns the email address from the authenticated user's token
 */
export function getUserEmail(userData: any): string {
  if (!userData) return '';

  // Try different possible locations for email in OIDC token
  // Standard OIDC claims location
  if (userData.profile?.email) {
    return userData.profile.email;
  }

  // Alternative location (some OIDC implementations)
  if (userData.email) {
    return userData.email;
  }

  // Fallback to preferred_username if email not available
  if (userData.profile?.preferred_username) {
    return userData.profile.preferred_username;
  }

  return '';
}

/**
 * Extract user display name from OIDC auth data
 */
export function getUserDisplayName(userData: any): string {
  if (!userData) return '';

  // Try name field
  if (userData.profile?.name) {
    return userData.profile.name;
  }

  // Try given_name + family_name
  if (userData.profile?.given_name || userData.profile?.family_name) {
    return [userData.profile.given_name, userData.profile.family_name].filter(Boolean).join(' ');
  }

  // Fallback to preferred_username
  if (userData.profile?.preferred_username) {
    return userData.profile.preferred_username;
  }

  return '';
}
